
import { appTheme } from '@ajc/lib-mui';
import { CssBaseline, ThemeProvider } from '@mui/material';

export default ({ element, props }) => {
  return (
    <ThemeProvider theme={appTheme}>
      <CssBaseline />
      {element}
    </ThemeProvider>
  )
}
